// extracted by mini-css-extract-plugin
module.exports = {"Link":"ShareArticle-module--Link--3aHed","ShareArticle":"ShareArticle-module--ShareArticle--2dThG","Methods":"ShareArticle-module--Methods--2tG3N"};